<template>
  <div class="container" v-if="posts">
  <div class="row justify-content-center">
    <div class="col-lg-9 text-center">
      <h3 class="fw-normal font-body">
        {{ posts.unsubscribe_1 }}
      </h3>
    </div>
  </div>
  <div class="row justify-content-center my-3">
    <div class="col-lg-8">
      <form class="form form--contact" method="post" @submit.prevent="submitForm($event)" id="formEmailAlerts" autocomplete="off">
        <Modal
          v-model="showModal"
          :title="formTitle"
          :status="formSuccess"
          :message="formMessage"
          @close="resetModal"
          template="emailAlertsUnsubscribe"
        />
    <div class="row">
      
      <div class="col-12">
        <div class="form-group">
          <label class="form-label" for="email_address">{{ translate("email") }}*</label>
          <input class="form-control" type="email" name="email_address" id="email_address" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" maxlength="50" required>
        </div>
      </div>

      <div class="col-12 text-center mt-3">
        <button 
          type="submit" 
          class="btn btn--secondary"
          >
          <span class="btn__title">{{translate('unsubscribe')}}</span>
        </button>
      </div>

    </div>

  </form>
    </div>
  </div></div>
</template>

<script setup>
import { useEmailAlertsUnsubscribe } from "@/composables/useEmailAlertsUnsubscribe";

import Modal from "@/components/helpers/Modal.vue";
import Loading from "@/components/helpers/Loading.vue";

const props = defineProps({
  posts: {
    type: Object,
    required: true,
  },
});

// ใช้ Composable
const {
  isLoading,
  LoadingTitle,
  formSuccess,
  formTitle,
  formMessage,
  showModal,
  translate,
  submitForm,
  resetModal,
} = useEmailAlertsUnsubscribe();

</script>

<style lang="scss"></style>
